export default "__VITE_ASSET__BIT$0dWZ__"